import {Component, Input, ViewEncapsulation} from '@angular/core';
import { MaterialModule } from "src/app/app.materials";
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-model-card',
  templateUrl: './model-card.component.html',
  styleUrls: ['./model-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MaterialModule, RouterModule, CommonModule],
  standalone: true,
})
export class ModelCardComponent {
  @Input() model: any;
  @Input() superAdmin = false;
}
